import { rootUrl } from '@/constants';
import axios from 'axios';

export type SubmitGetCode = {
  email: string;
};

export type ResponseGetCode = {
  token: string;
  isRegistered: boolean;
};

export const getCode = async (data: SubmitGetCode) => {
  const response = await axios.post<ResponseGetCode>(
    `${rootUrl}/psychologist/code`,
    {
      email: data.email,
    }
  );

  return response.data;
};
